import { all, takeLatest, call, put } from 'redux-saga/effects';
import { ActionType } from 'deox';
import axios from 'axios';
import { LegalDocumentType } from '@/types';
import env from '@/env';
import { loadHtmlActions } from '../actions/htmls';


const legalDocuments = {
  [LegalDocumentType.TERMS_OF_USE]: env.htmls['terms-of-use'],
  [LegalDocumentType.ABOUT_US]:env.htmls['about-us'],
  [LegalDocumentType.PRIVACY_POLICY]:env.htmls['privacy-policy'],
  [LegalDocumentType.FAQ]: env.htmls.faq,
};

export function* fetchHtmlsSaga(action: ActionType<typeof loadHtmlActions.request>) {
  try {
    const { htmlDocumentType } = action.payload;
    const { data: html } = yield call(axios.get, legalDocuments[htmlDocumentType]);

    yield put(loadHtmlActions.success(htmlDocumentType, html));
  } catch (err) {
    yield put(loadHtmlActions.failure(err));
  }
}

export default function* root() {
  yield all([takeLatest(loadHtmlActions.request.type, fetchHtmlsSaga)]);
}
